import { useContext } from "react";
import { SyncSaleContext } from "./context";

export const useQueue = () => {};

export const useSaleSyncProvider = () => {
  const context = useContext(SyncSaleContext);
  if (!context) {
    throw new Error("No SyncSaleContext context was provided. ");
  }
  return context;
};
